import initHomeGrid from './components/home/grid';

const gridEl = document.querySelector('.js-grid');

if (gridEl) {
    initHomeGrid(gridEl);
}
